function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { DisabledMixin } from './disabled-mixin.js';
/**
 * A mixin to toggle the `tabindex` attribute.
 *
 * The attribute is set to -1 whenever the user disables the element
 * and restored with the last known value once the element is enabled.
 *
 * @polymerMixin
 * @mixes DisabledMixin
 */

export var TabindexMixin = function TabindexMixin(superclass) {
  return /*#__PURE__*/function (_DisabledMixin) {
    _inherits(TabindexMixinClass, _DisabledMixin);

    var _super = _createSuper(TabindexMixinClass);

    function TabindexMixinClass() {
      _classCallCheck(this, TabindexMixinClass);

      return _super.apply(this, arguments);
    }

    _createClass(TabindexMixinClass, [{
      key: "_disabledChanged",
      value:
      /**
       * When the element gets disabled, the observer saves the last known tabindex
       * and makes the element not focusable by setting tabindex to -1.
       * As soon as the element gets enabled, the observer restores the last known tabindex
       * so that the element can be focusable again.
       *
       * @protected
       * @override
       */
      function _disabledChanged(disabled, oldDisabled) {
        _get(_getPrototypeOf(TabindexMixinClass.prototype), "_disabledChanged", this).call(this, disabled, oldDisabled);

        if (disabled) {
          if (this.tabindex !== undefined) {
            this._lastTabIndex = this.tabindex;
          }

          this.tabindex = -1;
        } else if (oldDisabled) {
          this.tabindex = this._lastTabIndex;
        }
      }
      /**
       * When the user has changed tabindex while the element is disabled,
       * the observer reverts tabindex to -1 and rather saves the new tabindex value to apply it later.
       * The new value will be applied as soon as the element becomes enabled.
       *
       * @protected
       */

    }, {
      key: "_tabindexChanged",
      value: function _tabindexChanged(tabindex) {
        if (this.disabled && tabindex !== -1) {
          this._lastTabIndex = tabindex;
          this.tabindex = -1;
        }
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * Indicates whether the element can be focused and where it participates in sequential keyboard navigation.
           *
           * @protected
           */
          tabindex: {
            type: Number,
            reflectToAttribute: true,
            observer: '_tabindexChanged'
          },

          /**
           * Stores the last known tabindex since the element has been disabled.
           *
           * @protected
           */
          _lastTabIndex: {
            type: Number
          }
        };
      }
    }]);

    return TabindexMixinClass;
  }(DisabledMixin(superclass));
};